var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFaceMeh = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-meh 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "face-meh",
    d: "M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM16.25 10C16.25 8.986 15.725 8.25 15 8.25C14.275 8.25 13.75 8.986 13.75 10C13.75 11.014 14.275 11.75 15 11.75C15.725 11.75 16.25 11.014 16.25 10ZM10.25 10C10.25 8.986 9.725 8.25 9 8.25C8.275 8.25 7.75 8.986 7.75 10C7.75 11.014 8.275 11.75 9 11.75C9.725 11.75 10.25 11.014 10.25 10ZM15.75 16C15.75 15.586 15.414 15.25 15 15.25H9C8.586 15.25 8.25 15.586 8.25 16C8.25 16.414 8.586 16.75 9 16.75H15C15.414 16.75 15.75 16.414 15.75 16Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFaceMeh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/face-meh.13bbd713.svg";
export { ForwardRef as ReactComponent };